module.exports = __webpack_public_path__ + "static/media/night-train.d148aa88.png";